import React from "react";
import usePageMeta from "@/hooks/usePageMeta";
import { useI18n } from "@/i18n";
import { PageHero } from "@/components/PageHero";
import { ASSETS } from "@/data/content";
import Bydgoszcz from "@/components/sections/Bydgoszcz";
import Torun from "@/components/sections/Torun";
import Surroundings from "@/components/sections/Surroundings";
import GuideDownload from "@/components/GuideDownload";

export default function Okolica() {
  const { t } = useI18n();
  usePageMeta(t.meta.okolica.title, t.meta.okolica.desc);
  return (
    <>
      <PageHero
        image={ASSETS.surrRiver}
        alt={t.pageHero.okolica.alt}
        title={t.pageHero.okolica.title}
        subtitle={t.pageHero.okolica.subtitle}
        heightClass="h-[62svh] min-h-[460px] md:h-[74svh]"
      />
      <Bydgoszcz />
      <GuideDownload testid="guide-download-top" />
      <Torun />
      <Surroundings />
      <GuideDownload testid="guide-download-bottom" />
    </>
  );
}
